import { jsx as r } from "react/jsx-runtime";
import { c as b } from "../../../index-Cu0xwYjD.js";
import { forwardRef as v, useEffect as l } from "react";
import { useIdIfNeeded as x } from "../../../utils/hooks/useIdIfNeeded.js";
import { useTabSetItems as u } from "../hooks/useTabSetItems.js";
import { TabSetItem as I } from "../components/TabSetItem.js";
const N = "ids-tab-v501", T = "ids-tab--active-v501", a = {
  tab: N,
  active: T
}, h = ({
  active: p,
  children: o,
  className: n,
  label: d,
  value: i,
  "data-testid": m,
  ...s
}, f) => {
  const e = x(s), t = u();
  l(() => {
    t == null || t.register({
      id: e,
      panel: o,
      value: i
    });
  }, [e, o, t, i]);
  const c = t ? t.isActive(e, i) : p;
  return t ? /* @__PURE__ */ r(
    I,
    {
      index: t.indexOf(e, i),
      handleSelection: t.activate,
      selected: c,
      value: i,
      children: /* @__PURE__ */ r(
        "button",
        {
          className: b(n, a.tab, {
            [a.active]: c
          }),
          "aria-controls": o ? `${e}--panel` : void 0,
          role: "tab",
          "data-testid": m,
          ...s,
          id: e,
          ref: f,
          children: d
        }
      )
    }
  ) : /* @__PURE__ */ r(
    "button",
    {
      className: b(n, a.tab, {
        [a.active]: c
      }),
      "data-testid": m,
      ...s,
      id: e,
      ref: f,
      children: d
    }
  );
}, E = v(h);
export {
  E as IressTab
};
